import { CommonEndpoint } from '@constants/ApiEndpoints';
import { AxiosInstance } from 'axios';
import { GlobalSettingsModel } from 'models/Shared/GlobalSettingsModel';

export interface GlobalSettingsServiceModel {
  get: ReturnType<typeof get>;
}

export const initGlobalSettingsService = (axios: AxiosInstance): GlobalSettingsServiceModel => ({
  get: get(axios),
});

export const get = (axios: AxiosInstance) => async (): Promise<GlobalSettingsModel> => {
  return await axios.get(CommonEndpoint.GLOBAL_SETTINGS).then(({ data }) => data);
};
